import { render } from "./AllProducts.vue?vue&type=template&id=bc5ada26"
import script from "./AllProducts.vue?vue&type=script&lang=js"
export * from "./AllProducts.vue?vue&type=script&lang=js"
script.render = render

export default script